export default __webpack_public_path__ + "static/media/creditCard.dcdc6464.svg";